import React from "react"

import { ChildSelector } from "../../helpers/ChildSelector"

import WPImage, { DISPLAY_MODE } from "../_base/WPImage"

import * as hallFameStyles from "../../styles/world_championships/HallFame.module.css"

const HallFame = props => {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `title`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const subtitle = ChildSelector.select(
    content,
    `subtitle`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const name1 = ChildSelector.select(
    content,
    `name1`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const when1 = ChildSelector.select(
    content,
    `when1`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const name2 = ChildSelector.select(
    content,
    `name2`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const when2 = ChildSelector.select(
    content,
    `when2`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const name3 = ChildSelector.select(
    content,
    `name3`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const when3 = ChildSelector.select(
    content,
    `when3`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const name4 = ChildSelector.select(
    content,
    `name4`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const when4 = ChildSelector.select(
    content,
    `when4`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  const name5 = ChildSelector.select(
    content,
    `name5`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )
  const when5 = ChildSelector.select(
    content,
    `when5`,
    ChildSelector.SELECTOR_TYPE.TEXT,
  )

  return (
    <div className="container-fluid">
      <div className={`row ${hallFameStyles.wrapper}`}>
        <div className="col">
          <div style={{ display: "grid", gridAutoRows: "1fr" }}>
            <div
              style={{
                gridArea: "1/1",
                position: "relative",
                placeItems: "right",
                display: "grid",
                zIndex: 2,
              }}
            >
              <div className={`row g-0`}>
                <div className={`col-12 ${hallFameStyles.content}`}>
                  <div className={`row g-0`}>
                    <div className={`col-12 ${hallFameStyles.heading}`}>
                      <h4>{subtitle}</h4>
                      <h2>{title}</h2>
                    </div>
                  </div>
                  <div className={`row g-0 ${hallFameStyles.imageWrapper}`}>
                    <div className={`col-12 col-lg-4 ${hallFameStyles.image}`}>
                      <WPImage
                        holder={content}
                        selector={`image-1`}
                        mode={DISPLAY_MODE.normal}
                        className={`${hallFameStyles.image1}`}
                      />
                      <p className={`${hallFameStyles.name}`}>{name1}</p>
                      <p className={`${hallFameStyles.whenAndWhere}`}>
                        {when1}
                      </p>
                    </div>
                    <div className={`col-12 col-lg-4 ${hallFameStyles.image}`}>
                      <WPImage
                        holder={content}
                        selector={`image-2`}
                        mode={DISPLAY_MODE.normal}
                        className={`${hallFameStyles.image2}`}
                      />
                      <p className={`${hallFameStyles.name}`}>{name2}</p>
                      <p className={`${hallFameStyles.whenAndWhere}`}>
                        {when2}
                      </p>
                    </div>
                    <div className={`col-12 col-lg-4 ${hallFameStyles.image}`}>
                      <WPImage
                        holder={content}
                        selector={`image-3`}
                        mode={DISPLAY_MODE.normal}
                        className={`${hallFameStyles.image3}`}
                      />
                      <p className={`${hallFameStyles.name}`}>{name3}</p>
                      <p className={`${hallFameStyles.whenAndWhere}`}>
                        {when3}
                      </p>
                    </div>
                    <div className={`col-12 col-lg-4 ${hallFameStyles.image}`}>
                      <WPImage
                        holder={content}
                        selector={`image-4`}
                        mode={DISPLAY_MODE.normal}
                        className={`${hallFameStyles.image4}`}
                      />
                      <p className={`${hallFameStyles.name}`}>{name4}</p>
                      <p className={`${hallFameStyles.whenAndWhere}`}>
                        {when4}
                      </p>
                    </div>
                    <div className={`col-12 col-lg-4 ${hallFameStyles.image}`}>
                      <WPImage
                        holder={content}
                        selector={`image-5`}
                        mode={DISPLAY_MODE.normal}
                        className={`${hallFameStyles.image5}`}
                      />
                      <p className={`${hallFameStyles.name}`}>{name5}</p>
                      <p className={`${hallFameStyles.whenAndWhere}`}>
                        {when5}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={`${hallFameStyles.backgroundContainmentImage}`}
              style={{
                gridArea: "1/1",
                objectFit: "cover",
                placeItems: "right",
                zIndex: 1,
              }}
              objectfit="cover"
              placeholderstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              imgstyle={{
                objectFit: `cover`,
                objectPosition: `right bottom`,
              }}
              transformoptions={{ fit: "cover" }}
            >
              <WPImage
                holder={content}
                selector={`media-asset`}
                mode={DISPLAY_MODE.normal}
                className={`${hallFameStyles.backgroundImage}`}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default HallFame
